<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y    
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-bind="$attrs"
        v-model="displayDataFormatted"
        persistent-hint
        v-on="on"                
        @keypress="format"     
        @keyup="checkTab"
        autocomplete="off"        
        @blur="leave"   
      ></v-text-field>
    </template>
    <v-date-picker locale="pt-br" v-model="date" @input="menu = false"></v-date-picker>
  </v-menu>
</template>

<script>



//const locale = i18n.locale;

export default {
  name: "CustomerDatepicker",
  props: ["value"],
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: "",
      menu: false
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    displayDataFormatted: {
      get() {
        if (!this.value) return this.dateFormatted;
        return this.formatDate(this.value);
      },
      set(val) {        
        if (!val) val = "";

        let newValue = null;
        
        if (val.length === 10) {
          newValue = this.parseDate(val);
        } else {
          this.dateFormatted = val;
        }
        this.$emit("input", newValue);
      }
    }
  },
  watch: {    
    value(val) {        
        if (val === null && this.displayDataFormatted !== "")
            this.displayDataFormatted = "";
    },
    date() {
      this.displayDataFormatted = this.date;      
    }
  },
  methods: {    
    leave() {                   
        if (this.dateFormatted.length === 8) {            
            this.displayDataFormatted = this.dateFormatted.substr(0, 2) + '/' + this.dateFormatted.substr(2,2) + "/" + this.dateFormatted.substr(4, 4);
            this.menu = false;
        } else if(this.dateFormatted.length > 0 && this.dateFormatted.length < 8) {            
            this.displayDataFormatted = "";
            this.menu = false;
        }
    },
    checkTab(e) {
      if (e.keyCode === 9) {
        //this.menu = false;  
        setTimeout(() => this.menu = false, 100);
        
      }
    },
    format(e) {      
      
      if ((e.keyCode < 47 || e.keyCode > 57) && e.keyCode != 45) e.preventDefault();
      return;
    }
  }
};
</script>

